/**
 * Classic G: an amoeba in a brick basin (docs/spec/03 §2). Plug the gaps in the basin's roof
 * before it gets out: sealed in, it turns to diamonds; loose, it swamps the cave and turns to stone.
 */

import type { CaveDef } from '../types';

export const caveG: CaveDef = {
  id: 'G',
  name: 'GREEN TIDE',
  hint: 'Keep the green stuff in its basin. It will thank you.',
  intermission: false,
  colors: [5, 12, 1],
  diamondValue: 15,
  extraValue: 30,
  amoebaTime: 20,
  fill: { base: '.', items: [['r', 8], ['d', 4]] },
  levels: [
    { seed: 1801, diamonds: 23, time: 150 },
    { seed: 1802, diamonds: 30, time: 145 },
    { seed: 1803, diamonds: 35, time: 140 },
    { seed: 1804, diamonds: 40, time: 135 },
    { seed: 1805, diamonds: 45, time: 130 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...???????????????????????????????????W',
    'W.P.???????????????????????????????????W',
    'W...???????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W????????r..????r..??.??r..???r..??????W',
    'W????wwwww wwwwww wwwdwww wwwww www????W',
    'W????w????????????????????????????w????W',
    'W????w????????????????????????????w????W',
    'W????w????????????????????????????w????W',
    'W????w????????????????????????????w????W',
    'W????w??????????????a?????????????w????W',
    'W????wwwwwwwwwwwwwwwwwwwwwwwwwwwwww??X?W',
    'W??????????????????????????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
